import BaseResource from './BaseResource';
import { ShopResourceInterface } from '../middleware.types';

export default class ShopResource extends BaseResource implements ShopResourceInterface {
}
